var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.07031C5.88454 5.07031 4.57031 6.38457 4.57031 8C4.57031 9.61543 5.88454 10.9297 7.5 10.9297C9.11546 10.9297 10.4297 9.61543 10.4297 8C10.4297 6.38457 9.11546 5.07031 7.5 5.07031ZM7.5 9.75781C6.53074 9.75781 5.74219 8.96926 5.74219 8C5.74219 7.03074 6.53074 6.24219 7.5 6.24219C8.46926 6.24219 9.25781 7.03074 9.25781 8C9.25781 8.96926 8.46926 9.75781 7.5 9.75781Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8069 7.69013C14.2323 6.76798 11.3083 2.72656 7.5 2.72656C3.69258 2.72656 0.767754 6.76792 0.193096 7.69013L0 8L0.193096 8.30987C0.767695 9.23202 3.69173 13.2734 7.5 13.2734C11.3074 13.2734 14.2322 9.23208 14.8069 8.30987L15 8L14.8069 7.69013ZM7.5 12.1016C4.54582 12.1016 2.11342 9.0033 1.40309 7.99953C2.1121 6.99494 4.53826 3.89844 7.5 3.89844C10.454 3.89844 12.8863 6.99626 13.5969 8.00047C12.8879 9.00509 10.4617 12.1016 7.5 12.1016Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.096592bd12afc6dbb499a8a9432f773f.svg";
export { ForwardRef as ReactComponent };